export default __webpack_public_path__ + "static/media/Mysore_Garden in Mysore.bf522170.jpg";